import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { MatDrawer } from '@angular/material/sidenav';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-navigator-with-menu',
  templateUrl: './navigator-with-menu.component.html',
  styleUrls: ['./navigator-with-menu.component.css'],
})
export class NavigatorWithMenuComponent implements OnInit {
  @ViewChild('drawer') drawer: MatDrawer;
  navBarTitle: string = ``;
  title = 'church-web';
  showDrawer = false;
  userName;
  userAvatar = null;
  drawerMode: 'push' | 'side' | 'over';
  allRouters = [
    { name: 'membro', icon: 'icon-people' },
    { name: 'area', icon: 'icon-people' },
    { name: 'setor', icon: 'icon-sector' },
    { name: 'celula', icon: 'icon-groups' },
    { name: 'patrimonio', icon: 'icon-patrimony' },
    { name: 'frequencia', icon: 'icon-frequency' },
    { name: 'palavra', icon: 'icon-article' },
    { name: 'crianca', icon: 'icon-child' },
    { name: 'banners', icon: 'banners' },
    { name: 'permissoes', icon: 'icon-permissions' },
    { name: 'devocional', icon: 'icon-quiz' },
  ];
  authorizedRoutersFromStorage = JSON.parse(sessionStorage.getItem('routes'));
  routers = this.allRouters.filter((router) => this.authorizedRoutersFromStorage?.includes(router.name));
  cecid = JSON.parse(sessionStorage.getItem('cecid'));

  constructor(private router: Router) {}

  ngOnInit(): void {
    if (window.innerWidth < 800) {
      this.drawerMode = 'over';
    } else {
      this.drawerMode = 'side';
    }

    if (sessionStorage.getItem('userAvatar')) {
      this.userAvatar = environment.endPointApi + 'user/avatar/' + sessionStorage.getItem('userAvatar');
    }
    this.userName = sessionStorage.getItem('userName');
  }
  logout() {
    const confirm = window.confirm('Deseja sair do sistema ?');
    if (confirm) {
      sessionStorage.clear();
      this.router.navigateByUrl('/');
    }
  }

  closeDrawer() {
    if (window.innerWidth < 800) this.drawer.toggle();
  }
}
